import React, { useState } from 'react';
import ImageWrapper from '../components/ImageWrapper';
import { marqueeData } from '../utils/marquee';

function BeforeAfter() {
    const [modalData, setModalData] = useState(null);

    return (
        <>
            <div className="hero w-full bg-hero-home-dark lg:bg-hero-home bg-cover h-[70vh]">
                <div className="gsap_reveal page__width flex flex-col gap-4 items-center text-center h-full justify-center">
                    <h1 className="font-extrabold text-3xl lg:text-5xl lg:w-1/2 text-white">
                        Преди и След
                    </h1>
                </div>
            </div>
            <div className="my-40 flex flex-col items-center">
                <div className="flex items-center gap-1">
                    <div className="bg-brand w-16 rounded-full h-[6px]"></div>
                    <div className="bg-brand w-8 rounded-full h-[6px]"></div>
                    <div className="bg-brand w-2 rounded-full h-[6px]"></div>
                </div>
                <h2 className="text-center text-2xl lg:text-3xl font-extrabold text-heading w-5/6 mx-auto mb-8">
                    А ето и какво постигаме с пациентите си:
                </h2>
                <div className="w-full flex flex-wrap items-center justify-center gap-4">
                    {marqueeData[0].map((img) => {
                        return (
                            <ImageWrapper
                                src={img.src}
                                alt={img.alt}
                                className="w-3/12 lg:w-[15%] h-auto rounded-lg hover:scale-90 duration-300 transition-all cursor-pointer"
                                onClick={() => setModalData(img)}
                            />
                        );
                    })}
                </div>
                <div className="w-full flex flex-wrap mt-4 items-center justify-center gap-4">
                    {marqueeData[1].map((img) => {
                        return (
                            <ImageWrapper
                                src={img.src}
                                alt={img.alt}
                                className="w-3/12 lg:w-[15%] h-auto rounded-lg hover:scale-90 duration-300 transition-all cursor-pointer"
                                onClick={() => setModalData(img)}
                            />
                        );
                    })}
                </div>
                {modalData ? (
                    <div className="w-screen h-screen flex items-center justify-center fixed top-0 bottom-0 left-0 right-0 z-[99]">
                        <div
                            className="w-screen h-screen fixed top-0 bottom-0 left-0 right-0 bg-black bg-opacity-60"
                            onClick={() => setModalData(null)}></div>
                        <div className="relative flex flex-col lg:flex-row items-center gap-8 w-3/4 bg-white rounded-lg p-8 z-[999]">
                            <ImageWrapper
                                src={modalData.src}
                                alt="Modal Image"
                                className="w-full lg:w-1/3 rounded-lg"
                            />
                            <div className="flex w-full lg:w-2/3 flex-col gap-4 items-start">
                                <h3 className="text-2xl lg:text-3xl font-bold text-heading">
                                    {modalData.title}
                                </h3>
                                <p className="text-base lg:text-lg text-heading">
                                    {modalData.description}
                                </p>
                            </div>
                            <button
                                className="lg:absolute top-4 right-4 flex items-center justify-center rounded-full border-2 font-bold border-brand text-brand bg-none px-4 py-2 hover:text-white hover:bg-brand transition-all duration-200"
                                onClick={() => setModalData(null)}>
                                Затвори
                            </button>
                        </div>
                    </div>
                ) : null}
            </div>
        </>
    );
}

export default BeforeAfter;
